import { render, staticRenderFns } from "./SlotsWithinHour.vue?vue&type=template&id=644ecf6a&scoped=true&"
import script from "./SlotsWithinHour.vue?vue&type=script&lang=js&"
export * from "./SlotsWithinHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ecf6a",
  null
  
)

export default component.exports